/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown> }} Progress_Extra_Map_SetsInputs */

const en_us2_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} sets`)
};

const pt_br2_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries`)
};

const es_419_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} series`)
};

const pt_pt2_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries`)
};

const fr_fr2_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} séries`)
};

const de_de2_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} Sätze`)
};

const it_it2_progress_extra_map_sets = /** @type {(inputs: Progress_Extra_Map_SetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} serie`)
};

/**
* | output |
* | --- |
* | "{sets} sets" |
*
* @param {Progress_Extra_Map_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_sets = /** @type {((inputs: Progress_Extra_Map_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_sets(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_sets(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_sets(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_sets(inputs)
	return en_us2_progress_extra_map_sets(inputs)
});
export { progress_extra_map_sets as "progress-extra.map_sets" }